import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import UserModel from "../../Login/models/UserModel";
import UserDisplayNameModel from "../../UserSelector/models/UserDisplayNameModel";

export interface GetUserByIdParam {
    id: number,
}

export interface UpdateSignatureParam {
    signature: string,
}

const UserApi = {
    GetAll() {
        return Api.get<unknown, BaseResponse<UserModel[]>>("/api/User/GetAll", null);
    },
    GetDisplayNames() {
        return Api.get<unknown, BaseResponse<UserDisplayNameModel[]>>("/api/User/GetDisplayNames", null);
    },
    GetById(param: GetUserByIdParam) {
        return Api.get<GetUserByIdParam, BaseResponse<UserModel>>("/api/User/GetById", param);
    },
    Save(param: UserModel) {
        return Api.post<UserModel, BaseResponse<UserModel>>("/api/User/Save", param);
    },
    UpdateSignature(param: UpdateSignatureParam) {
        return Api.post<UpdateSignatureParam, BaseResponse<string>>("/api/Account/UpdateSignature", param);
    },
};
export default UserApi;